import script from "./LifespanBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./LifespanBar.vue?vue&type=script&lang=ts&setup=true"

import "./LifespanBar.vue?vue&type=style&index=0&id=9867f892&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9867f892"]])

export default __exports__